<ng-container *ngIf="loading$ | async; else loading">
	<mat-accordion>
		<mat-expansion-panel class="chat-expansion-panel"
							 *ngFor="let mapItem of conversations$ | async | keyvalue; trackBy: trackByFn_conversations"
							 [expanded]="expandedPanelKey === mapItem.key?.id"
							 (opened)="expandedPanelKey = mapItem.key?.id">
			<mat-expansion-panel-header>
				<div class="conversation-header" [ngClass]="{ 'show-publisher-name': mapItem?.key?.label }">
					<div *ngIf="mapItem.key" class="publisher">{{ mapItem.key.label }}</div>
					<ng-container *ngIf="mapItem.value.length && mapItem.value[mapItem.value.length - 1]; else nolastmessage; let message">
						<div class="message-avatar" [ngStyle]="message | avatarColours">
							<div class="message-avatar-text" [innerHTML]="message | avatarText"></div>
						</div>
						<div class="timestamp">
							{{ message.timestamp | cassTimestamp }}
						</div>
						<div class="message-block">
							<span class="message-sender">
								{{
								(message.senderUserID && message.senderUserID === currentUserId
									? ("CHAT_MESSAGES.SENDER_IS_YOU_LABEL" | translate)
									: message.senderUserName ?? ("CHAT_MESSAGES.UNKNOWN_SENDER_LABEL" | translate))
							  + (message.senderCompanyId ? " (" + mapItem.key?.label + ")" : "")
								}}
							</span>
							<span class="message-text">{{ message.messageText }}</span>
						</div>
					</ng-container>
					<ng-template #nolastmessage>
						<div class="message-avatar" [ngStyle]="{ 'background-color': '#eee' }">
							<div class="message-avatar-text">+</div>
						</div>
						<div class="message-block">
							<div class="message-text" *ngIf="!mapItem.key">{{ "CHAT_MESSAGES.ORDER_CONVERSATIONS.SEND_MESSAGE_TO_THE_PUBLISHER" | translate }}</div>
							<div class="message-text" *ngIf="mapItem.key">
								<span *ngIf="isChatEnabledForPublisher(mapItem.key?.id); else contactRepresentative">{{ "CHAT_MESSAGES.ORDER_CONVERSATIONS.SEND_MESSAGE_TO_PARAM" | translate:{to: mapItem.key.label} }}</span>
							</div>
						</div>
					</ng-template>
				</div>
			</mat-expansion-panel-header>
			<div *ngIf="(!(mapItem.key && mapItem.key.id) || isChatEnabledForPublisher(mapItem.key?.id)); else contactRepresentative" class="conversation-container">
				<app-chat-panel [messages]="mapItem.value" [orderId]="orderId" [currentUserId]="currentUserId" [publisher]="mapItem.key" [scrollToMessageId]="scrollToMessageId" (messageSent)="messageSent()"></app-chat-panel>
			</div>
			<ng-template #contactRepresentative>
				<span *ngIf="mapItem.key">{{ "CHAT_MESSAGES.ORDER_CONVERSATIONS.CONTACT_REPRESENTATIVE" | translate:{ publisher: mapItem.key.label } }}</span>
			</ng-template>
		</mat-expansion-panel>
	</mat-accordion>
</ng-container>
<ng-template #loading>
	<cass-indeterminate-circular-progress-indicator></cass-indeterminate-circular-progress-indicator>
</ng-template>
